import { render, staticRenderFns } from "./TeacherExportMonthlyAttendancePage.vue?vue&type=template&id=4c875e6e&scoped=true&"
import script from "./TeacherExportMonthlyAttendancePage.vue?vue&type=script&lang=js&"
export * from "./TeacherExportMonthlyAttendancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c875e6e",
  null
  
)

export default component.exports